module.exports = __webpack_public_path__ + "img/qrcode-tips.a8e2db5d.png";